module.exports = __webpack_public_path__ + "img/app.c4ad4d90.png";